const SNAPSHOT_KEY = "cc:agentAlertSnapshot";

const playTone = (frequency, durationMs, volume = 0.15) => {
  if (typeof window === "undefined") return;
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const context = new AudioContext();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.type = "sine";
    oscillator.frequency.value = frequency;
    gain.gain.value = volume;
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start();
    setTimeout(() => {
      oscillator.stop();
      context.close();
    }, durationMs);
  } catch {
    // Ignore audio failures (autoplay policy, unsupported browser, etc.)
  }
};

export const playAgentAlertSound = (severity = "warning") => {
  if (severity === "escalation") {
    playTone(880, 180);
    setTimeout(() => playTone(660, 220), 200);
    return;
  }
  playTone(740, 160);
};

export const showAgentAlertBrowserNotification = ({ title, body, urgent = false }) => {
  if (typeof window === "undefined" || !("Notification" in window)) return;
  const notify = () => {
    try {
      new Notification(title, {
        body,
        tag: "cc-agent-alert",
        requireInteraction: urgent,
      });
    } catch {
      // Ignore notification failures.
    }
  };
  if (Notification.permission === "granted") {
    notify();
    return;
  }
  if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") notify();
    });
  }
};

export const processAgentAlertNotifications = (alerts, summary, t = (key) => key) => {
  if (typeof window === "undefined" || !Array.isArray(alerts)) return;
  const items = alerts.map((alert) => ({ id: alert.id, status: alert.status }));
  const signature = JSON.stringify({
    items,
    escalated: Number(summary?.escalatedCount ?? summary?.escalated ?? 0),
    attention: Number(summary?.attentionCount ?? summary?.attention ?? 0),
    warning: Number(summary?.warningCount ?? summary?.warning ?? 0),
  });
  const previous = sessionStorage.getItem(SNAPSHOT_KEY);
  if (previous && previous !== signature) {
    let prevData;
    try {
      prevData = JSON.parse(previous);
    } catch {
      prevData = null;
    }
    if (prevData) {
      const escalatedIncreased =
        Number(summary?.escalatedCount ?? summary?.escalated ?? 0) > Number(prevData.escalated || 0);
      const newWarning = items.some(
        (item) =>
          item.status === "WARNING" &&
          !prevData.items?.some((prev) => prev.id === item.id && prev.status === "WARNING")
      );
      const newAttention =
        Number(summary?.attentionCount ?? summary?.attention ?? 0) > Number(prevData.attention || 0);
      if (escalatedIncreased) {
        playAgentAlertSound("escalation");
        showAgentAlertBrowserNotification({
          title: t("ccAlertNotificationEscalatedTitle"),
          body: t("ccAlertNotificationEscalatedBody"),
          urgent: true,
        });
      } else if (newWarning || newAttention) {
        playAgentAlertSound("warning");
        showAgentAlertBrowserNotification({
          title: t("ccAlertNotificationWarningTitle"),
          body: t("ccAlertNotificationWarningBody"),
        });
      }
    }
  }
  sessionStorage.setItem(SNAPSHOT_KEY, signature);
};
